// Step keys for the Dyrejournal getting-started card. Order = display order.
// Keys MUST match the `steps` object returned by GET /api/dyrejournal/getting-started
// and the values stored in customer.gettingStartedOverrides.
const STEP_KEYS = [
    'visitor',
    'animal',
    'journal',
    'product',
    'saleProduct',
    'payment',
    'template',
    'productTemplate',
    'templateSale',
];

// `keys` defaults to the Dyrejournal list; other products (the shooting-club
// card in lib/clubGettingStartedSteps.js) pass their own key list.
function computeStepStates(apiSteps, overrides, keys = STEP_KEYS) {
    const steps = apiSteps || {};
    const manual = Array.isArray(overrides) ? overrides : [];
    const stepKeys = Array.isArray(keys) ? keys : STEP_KEYS;
    return stepKeys.map(key => {
        const auto = steps[key] === true;
        const overridden = !auto && manual.includes(key);
        return {
            key,
            done: auto || overridden,
            auto,
            overridden,
        };
    });
}

function countDone(stepStates) {
    return stepStates.filter(s => s.done).length;
}

export { STEP_KEYS, computeStepStates, countDone };
